import { render } from "./Comments.vue?vue&type=template&id=417b236a&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=417b236a&scoped=true&lang=css"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417b236a"]])

export default __exports__